// FETCH ALL DYEING INWARD
export const FETCH_DYEING_INWARD_MASTER_REQUEST_DK = 'FETCH_DYEING_INWARD_MASTER_REQUEST_DK';
export const FETCH_DYEING_INWARD_MASTER_SUCCESS_DK = 'FETCH_DYEING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_DYEING_INWARD_MASTER_FAILURE_DK = 'FETCH_DYEING_INWARD_MASTER_FAILURE_DK';

// CREATE DYEING INWARD
export const CREATE_DYEING_INWARD_MASTER_REQUEST_DK = 'CREATE_DYEING_INWARD_MASTER_REQUEST_DK';
export const CREATE_DYEING_INWARD_MASTER_SUCCESS_DK = 'CREATE_DYEING_INWARD_MASTER_SUCCESS_DK';
export const CREATE_DYEING_INWARD_MASTER_FAILURE_DK = 'CREATE_DYEING_INWARD_MASTER_FAILURE_DK';

// UPDATE DYEING INWARD
export const UPDATE_DYEING_INWARD_MASTER_REQUEST_DK = 'UPDATE_DYEING_INWARD_MASTER_REQUEST_DK';
export const UPDATE_DYEING_INWARD_MASTER_SUCCESS_DK = 'UPDATE_DYEING_INWARD_MASTER_SUCCESS_DK';
export const UPDATE_DYEING_INWARD_MASTER_FAILURE_DK = 'UPDATE_DYEING_INWARD_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF DYEING INWARD
export const FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST_DK = 'FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST_DK';
export const FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS_DK = 'FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE_DK = 'FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE_DK';

// DELETE DYEING INWARD
export const DELETE_DYEING_INWARD_MASTER_REQUEST_DK = 'DELETE_DYEING_INWARD_MASTER_REQUEST_DK';
export const DELETE_DYEING_INWARD_MASTER_SUCCESS_DK = 'DELETE_DYEING_INWARD_MASTER_SUCCESS_DK';
export const DELETE_DYEING_INWARD_MASTER_FAILURE_DK = 'DELETE_DYEING_INWARD_MASTER_FAILURE_DK';

export const FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE_DK';

export const RESET_DYEING_INWARD_MASTER_INFO_DK = 'RESET_DYEING_INWARD_MASTER_INFO_DK';

export const CREATE_DYEING_INWARD_MASTER_FORM_DK = 'CREATE_DYEING_INWARD_MASTER_FORM_DK';

export const UPDATE_DYEING_INWARD_MASTER_FORM_DK = 'UPDATE_DYEING_INWARD_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_DYEING_INWARD_DETAILS_DK = 'NAVIGATE_DYEING_INWARD_DETAILS_DK';

// NAVIGATE TO DYEING INWARD COMPONENT
export const NAVIGATE_DYEING_INWARD_MASTER_DK = 'NAVIGATE_DYEING_INWARD_MASTER_DK';

export const RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID_DK';

export const SET_ACTIVE_KEY_DYEING_INWARD_DK = 'SET_ACTIVE_KEY_DYEING_INWARD_DK';

export const SET_PENDING_GRID_NAME_DYEING_INWARD_DK = 'SET_PENDING_GRID_NAME_DYEING_INWARD_DK';
export const SET_UNIT_NAME_DYEING_INWARD_DK = 'SET_UNIT_NAME_DYEING_INWARD_DK';

export const FETCH_COMPLETE_DYEING_PO_IN_INWARD_REQUEST_DK = 'FETCH_COMPLETE_DYEING_PO_IN_INWARD_REQUEST_DK';
export const FETCH_COMPLETE_DYEING_PO_IN_INWARD_SUCCESS_DK = 'FETCH_COMPLETE_DYEING_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_COMPLETE_DYEING_PO_IN_INWARD_FAILURE_DK = 'FETCH_COMPLETE_DYEING_PO_IN_INWARD_FAILURE_DK';

export const FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK';